"use strict";
/**
 * Mascaramento de dados pessoais.
 *
 * Aplicado antes de qualquer coisa sair para log, auditoria ou resposta de API
 * destinada a quem não é o titular do dado.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SENSITIVE_KEYS = void 0;
exports.maskEmail = maskEmail;
exports.maskPhone = maskPhone;
exports.maskIp = maskIp;
exports.redact = redact;
/** "douglas.emanoel@gmail.com" → "d***l@gmail.com". */
function maskEmail(email) {
    const [local, domain] = email.split('@');
    if (!local || !domain)
        return '***';
    if (local.length <= 2)
        return `${local.charAt(0)}***@${domain}`;
    return `${local.charAt(0)}***${local.charAt(local.length - 1)}@${domain}`;
}
/** "5511987654321" → "(11) *****-4321". */
function maskPhone(phone) {
    const digits = phone.replace(/\D/g, '').replace(/^55/, '');
    if (digits.length < 4)
        return '***';
    return `(${digits.slice(0, 2)}) *****-${digits.slice(-4)}`;
}
/**
 * IP mascarado para auditoria: IPv4 perde o último octeto, IPv6 mantém só o
 * prefixo /48. Mantém utilidade forense sem guardar o identificador completo.
 */
function maskIp(ip) {
    if (!ip)
        return null;
    if (ip.includes(':')) {
        const groups = ip.split(':').filter(Boolean);
        return `${groups.slice(0, 3).join(':')}::`;
    }
    const octets = ip.split('.');
    if (octets.length !== 4)
        return null;
    return `${octets[0]}.${octets[1]}.${octets[2]}.0`;
}
/** Chaves cujo valor nunca deve aparecer em log ou auditoria. */
exports.SENSITIVE_KEYS = new Set([
    'password',
    'passwordhash',
    'currentpassword',
    'newpassword',
    'confirmpassword',
    'token',
    'accesstoken',
    'refreshtoken',
    'authorization',
    'cookie',
    'secret',
    'clientsecret',
    'apikey',
    'pixkey',
    'cpf',
    'cnpj',
    'creditcard',
    'cardnumber',
    'cvv',
    'otp',
    'code',
]);
/**
 * Substitui recursivamente valores sensíveis por "[REDACTED]".
 * Usado no interceptor de log e no serviço de auditoria.
 */
function redact(value, depth = 0) {
    if (depth > 8 || value === null || value === undefined)
        return value;
    if (Array.isArray(value)) {
        return value.map((item) => redact(item, depth + 1));
    }
    if (typeof value === 'object') {
        const source = value;
        const result = {};
        for (const [key, entry] of Object.entries(source)) {
            result[key] = exports.SENSITIVE_KEYS.has(key.toLowerCase())
                ? '[REDACTED]'
                : redact(entry, depth + 1);
        }
        return result;
    }
    return value;
}
//# sourceMappingURL=privacy.js.map